import axios from 'axios';

export const createPurchaseRecord = async (data)=>{
  return new Promise((resolve, reject) => {
    axios.post(`${process.env.REACT_APP_URL_API}/purchase-records`,data)
      .then(res=>resolve(res))
      .catch(err => reject(err));
  });
}